var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-section-info"},[_c('div',{staticClass:"custom-html-wrapper",class:_vm.customHtmlContentClass,domProps:{"innerHTML":_vm._s(_vm.contents.contentBody)}})])}
var staticRenderFns = []

export { render, staticRenderFns }